export const idx_data_flexibility = [];

idx_data_flexibility.push({
  flexibility: "",
});

idx_data_flexibility.push({
  flexibility: "75",
});

idx_data_flexibility.push({
  flexibility: "90",
});

idx_data_flexibility.push({
  flexibility: "105",
});

idx_data_flexibility.push({
  flexibility: "120",
});

idx_data_flexibility.push({
  flexibility: "135",
});

idx_data_flexibility.push({
  flexibility: "PRO",
});
